import { useQuery } from '@apollo/client'
import { PERSON_DARN } from '../infra/queries'
import React from 'react'
import { useParams } from 'react-router-dom'
import { LoadingSpinner } from '../presentation/spinners'
import PersonView from '../presentation/PersonView'

const PersonContainer = () => {
  const { darn } = useParams()
  const { loading, error, data } = useQuery(PERSON_DARN, { variables: { darn } })

  if (loading) return <LoadingSpinner />
  if (error) throw error

  return <PersonView person={data.person} />
}

export default PersonContainer
